module.exports = __webpack_public_path__ + "img/Exodus.420a2205.jpg";